document.addEventListener('DOMContentLoaded', function() {
  const menuToggles = document.querySelectorAll('.footer-block-menu .footer-block-heading');

  menuToggles.forEach(toggle => {
    toggle.addEventListener('click', function() {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !expanded);
    });
  });
});